module.exports = __webpack_public_path__ + "img/offers-icon-change.9b917210.svg";